import { colors } from '../styles'

export const text = {
  baseStyle: {
    color: colors.gray[900],
  },
  sizes: {},
  variants: {
    subtitle1: {
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 600,
      fontStyle: 'normal',
    },
    subtitle2: {
      fontSize: 14,
      lineHeight: '18px',
      fontWeight: 600,
      fontStyle: 'normal',
    },
    form: {
      fontSize: 14,
      lineHeight: '17px',
      fontWeight: 700,
      fontStyle: 'normal',
    },
    subtitle3: {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 600,
      fontStyle: 'normal',
    },
    subtitle3disabled: {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 600,
      fontStyle: 'normal',
      color: colors.gray[400],
    },
    body1: {
      fontSize: '14px',
      // lineHeight: '28px',
      fontWeight: 500,
      fontStyle: 'normal',
    },
    body1ellipsis: {
      fontSize: '14px',
      lineHeight: '28px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      fontWeight: 500,
      fontStyle: 'normal',
    },
    body2: {
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: 'normal',
      fontStyle: 'normal',
    },
    body4: {
      fontSize: 16,
      lineHeight: '25px',
      fontWeight: 500,
      fontStyle: 'normal',
      textAlign: 'center',
    },
    bodyHyperLink: {
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      color: 'blue',
      _hover: {
        cursor: 'pointer',
        textDecoration: 'underline',
      },
    },
    body3: {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 'normal',
      fontStyle: 'normal',
    },
    bodyActive: {
      fontSize: '16px',
      lineHeight: '28px',
      fontWeight: 700,
      color: colors.text.default,
      fontStyle: 'normal',
    },
    bodyActive2: {
      fontSize: '14px',
      lineHeight: '22px',
      fontWeight: 700,
      color: colors.text.default,
      fontStyle: 'normal',
    },
    caption1: {
      fontSize: 14,
      lineHeight: '18px',
      fontWeight: 600,
      fontStyle: 'normal',
      letterSpacing: '0.5px',
    },
    caption2: {
      fontSize: 13,
      lineHeight: '17px',
      fontWeight: 'normal',
      fontStyle: 'normal',
    },
    overline: {
      fontSize: 14,
      lineHeight: '18px',
      fontWeight: 600,
      fontStyle: 'normal',
      letterSpacing: '1.2px',
      textTransform: 'uppercase',
    },
    placeholder: {
      color: colors.gray[400],
      fontSize: 13,
      fontWeight: 500,
    },
    small: {
      fontSize: 10,
      lineHeight: '17px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      letterSpacing: '-0.2px',
    },
    small2: {
      fontSize: 12,
      lineHeight: '17px',
      fontWeight: 500,
      fontStyle: 'normal',
      letterSpacing: '-0.2px',
    },
    regular: {
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '20px',
      color: '#4D4D4D',
    },
    warning: {
      fontSize: '14px',
      fontWeight: 700,
      lineHeight: '22px',
      color: colors.gray[900],
    },
    semibold: {
      fontSize: {
        base: '12px',
        sm: '12px',
        md: '14px',
        lg: '16px',
        xl: '16px',
      },
      fontWeight: 600,
      lineHeight: '20px',
      color: '#333333',
    },
    'rounded-button': {
      color: '#FFFFFF',
      lineHeight: '20px',
      fontSize: 16,
      fontWeight: ' bold',
    },
    h3: {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '22px',
      letterSpacing: '0em',
      textAlign: 'left',
    },
    h5: {
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '26px',
    },
    error: {
      fontSize: 14,
      lineHeight: '16px',
      fontWeight: 600,
      fontStyle: 'normal',
      color: colors.log.error,
    },
    button: {
      fontSize: 14,
      lineHeight: '14px',
      fontWeight: 700,
      fontStyle: 'normal',
      color: colors.text.default,
    },
    button13: {
      fontSize: 13,
      lineHeight: '22px',
      fontWeight: 600,
      fontStyle: 'normal',
    },
  },
  defaultProps: {
    variant: 'subtitle1',
  },
}
